import type TagManager from 'react-gtm-module';

type Product = 'nl-aov' | 'nl-pnc' | 'fr-pnc' | 'fr-decennale' | 'de-pnc';

type ProductConfig = {
  itemId: number;
};

const product: Record<Product, ProductConfig> = {
  'nl-aov': {
    itemId: 1,
  },
  'nl-pnc': {
    itemId: 2,
  },
  'fr-pnc': {
    itemId: 3,
  },
  'fr-decennale': {
    itemId: 4,
  },
  'de-pnc': {
    itemId: 5,
  },
} as const;

type SendPurchaseEventPayload<T extends Product> = {
  transaction_id: string;
  value: number; // Annual premium
  currency?: string;
  items?: [
    {
      item_id?: (typeof product)[T]['itemId'];
      item_name?: T;
      price?: number; // Annual premium
      quantity?: number;
    },
  ];
  item_id?: (typeof product)[T]['itemId'];
};

export type SendPurchaseEventFn<T extends Product> = (payload: SendPurchaseEventPayload<T>) => void;

export const makeSendPurchaseEvent =
  <T extends Product>(productType: T, tagManager: typeof TagManager): SendPurchaseEventFn<T> =>
  (payload) => {
    const item_id = payload.items?.[0].item_id || product[productType].itemId;
    const computedPayload: Required<SendPurchaseEventPayload<T>> = {
      ...payload,
      currency: payload.currency || 'EUR',
      items: [
        {
          item_id,
          item_name: payload.items?.[0].item_name || productType,
          price: payload.items?.[0].price || payload.value,
          quantity: payload.items?.[0].quantity || 1,
        },
      ],
      item_id,
    };

    tagManager.dataLayer({
      dataLayer: {
        event: 'purchase',
        ...computedPayload,
      },
    });
  };
